// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__tAIpt","tyre":"style_tyre__LvG32"};